@if (data.title) {
  <h1 mat-dialog-title sharedUiModalClose (closed)="close()">{{
    data.title
  }}</h1>
}

<ng-scrollbar autoHeightDisabled="false">
  <mat-dialog-content>
    <ng-container [ngTemplateOutlet]="data.menuHeader ?? null"></ng-container>

    <div (click)="onContentClick()">
      <ng-container [ngTemplateOutlet]="data.menuContent"></ng-container>
    </div>

    <ng-container [ngTemplateOutlet]="data.menuFooter ?? null"></ng-container>
  </mat-dialog-content>
</ng-scrollbar>

@if (!data.disableActions && data.actions && data.actions.length > 0) {
  <mat-dialog-actions class="mt-[20px]">
    @for (action of data.actions; track action.title) {
      @switch (action.type) {
        @case (MenuModalButtonTypeEnum.PRIMARY) {
          <shared-ui-button
            class="flex-1"
            size="stretch"
            (clicked)="runAction(action)"
            >{{ action.title }}</shared-ui-button
          >
        }
        @case (MenuModalButtonTypeEnum.SECONDARY) {
          <shared-ui-button
            class="flex-1"
            mode="outline"
            size="stretch"
            (clicked)="runAction(action)"
            >{{ action.title }}</shared-ui-button
          >
        }
      }
    }
  </mat-dialog-actions>
}
